exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\r\n    --brand-primary: #fff;\r\n    --brand-primary-light: #fff;\r\n    --brand-primary-dark: #fff;\r\n    --brand-secondary: #02bad4;\r\n    --brand-secondary-light: #62edff;\r\n    --brand-secondary-dark: #008aa3;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/~/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Users/GKool/source/repos/e2epublicwebsite/~/postcss-loader?{"ident":"postcss"}!C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/css/themes/horizontal-menu/variables.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/css/themes/horizontal-menu/variables.css
// module chunks = 0